export const SENTRY_DSN_URL =
  'https://50b7a1e98c2bd29d813ba668b86ccd10@o1100855.ingest.us.sentry.io/4510715259256832';
